import React from 'react';

export default () => (
    <svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 3V25C6 25.5523 6.44772 26 7 26H29V29H6C4.34315 29 3 27.6569 3 26V3H6Z" fill="url(#paint0_linear_2810_48573)" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6596 18.1407L11 15.0507V21H24V10.0747L15.6596 18.1407ZM25.6439 4.31149C26.1516 3.82049 27 4.18026 27 4.88656V22.5C27 23.3284 26.3284 24 25.5 24H9.5C8.67157 24 8 23.3284 8 22.5V10.9519C8 10.3139 8.71037 9.93258 9.24214 10.2852L15.3077 14.3076L25.6439 4.31149Z" fill="url(#paint1_linear_2810_48573)" />
        <defs>
            <linearGradient id="paint0_linear_2810_48573" x1="20.875" y1="30.5" x2="8.08885" y2="13.0285" gradientUnits="userSpaceOnUse">
                <stop stop-color="#BCBEC6" />
                <stop offset="1" stop-color="#BCBEC6" />
            </linearGradient>
            <linearGradient id="paint1_linear_2810_48573" x1="21.0625" y1="25.1489" x2="11.1386" y2="12.2115" gradientUnits="userSpaceOnUse">
                <stop stop-color="#BCBEC6" />
                <stop offset="1" stop-color="#BCBEC6" />
            </linearGradient>
        </defs>
    </svg>)